import { createRequestTypes } from 'common/websocket-redux';

export const EMPLOYEE_USER_BENEFITS_RESET =
  'employee/EMPLOYEE_USER_BENEFITS_RESET';
export const REQUEST_EMPLOYEE_RESET_USER_BENEFITS = createRequestTypes(
  'employee/REQUEST_EMPLOYEE_RESET_USER_BENEFITS',
);
